const SITE_URL = 'https://xperiencetattoo.com';

export const getLocalBusinessSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'XperienceTattoo',
  image: `${SITE_URL}/images/xperience-tattoo-logo.png`,
  description:
    'Premium tattoo experiences in Valencia combining tattoo artistry with travel and local culture.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Valencia',
    addressCountry: 'ES',
  },
  url: SITE_URL,
  telephone: '+34 123 456 789',
  priceRange: '€€€',
  sameAs: [
    'https://instagram.com/xperiencetattoo',
    'https://facebook.com/xperiencetattoo',
  ],
});

export const getBreadcrumbSchema = (items: { name: string; url: string }[]) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: item.name,
    item: `${SITE_URL}${item.url}`,
  })),
});

export const getFAQPageSchema = (
  questions: { question: string; answer: string }[]
) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: questions.map(q => ({
    '@type': 'Question',
    name: q.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: q.answer,
    },
  })),
});
